import { FC, ReactNode } from 'react';
import styles from './PunchupPageContent.module.css';

interface PunchupPageContentProps {
	children: ReactNode;
}

export const PunchupPageContent: FC<PunchupPageContentProps> = ({ children }) => (
	<div className={styles.root}>{children}</div>
);
